export const parvoVet = {
	formSchema: {
		us: {
			type: 'object',
			required: [
				'firstName',
				'lastName',
				'emailAddress',
				'caseDate',
				'clinicZipcode',
				'practiceName',
			],
			properties: {
				firstName: {
					type: 'string',
					title: 'First Name',
				},
				lastName: {
					type: 'string',
					title: 'Last Name',
				},
				emailAddress: {
					type: 'string',
					title: 'Email Address',
					pattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
				},
				caseDate: {
					type: 'string',
					title: 'Date of Diagnosis',
					format: 'date',
				},
				clinicZipcode: {
					type: 'string',
					title: 'Clinic Zip Code',
					pattern: '(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)',
				},
				practiceName: {
					type: ['string'],
					title: 'Practice Name',
				},
			},
		},
		testing: {
			type: 'object',
			required: [
				'firstName',
				'lastName',
				'emailAddress',
				'caseDate',
				'clinicZipcode',
				'practiceName',
			],
			properties: {
				firstName: {
					type: 'string',
					title: 'First Name',
				},
				lastName: {
					type: 'string',
					title: 'Last Name',
				},
				emailAddress: {
					type: 'string',
					title: 'Email address',
					pattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
				},
				caseDate: {
					type: 'string',
					title: 'Date of Diagnosis',
					format: 'date',
				},
				clinicZipcode: {
					type: 'string',
					title: 'Clinic Zip Code',
					pattern: '(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)',
				},
				practiceName: {
					type: ['string'],
					title: 'Practice Name',
				},
			},
		},
	},
	uiSchema: {
		'ui:rootFieldId': 'parvoVet',
		'ui:order': [
			'firstName',
			'lastName',
			'emailAddress',
			'caseDate',
			'clinicZipcode',
			'practiceName',
		],
		description:
			'By clicking “Submit” I agree to Elanco’s <a href="https://www.elancostatements.com/en/terms-of-use/elanco-com">Terms of Use</a>, and acknowledge that Elanco will collect and process my personal information in accordance with Elanco’s <a href="https://privacy.elanco.com/en-us">Privacy Notice</a>.',
	},
}
